import { createApp, defineAsyncComponent } from 'vue';
import emitter from '../plugins/emitter';

const app = createApp({
    components: {
        VueInteractions: defineAsyncComponent(() => import('../components/content/Interactions.vue')),
        VueComments: defineAsyncComponent(() => import('../components/content/Comments.vue')),
        VuePublication: defineAsyncComponent(() => import('../components/content/Publication.vue')),
    },
});

app.use(emitter);
app.mount('#vue__content__view');